import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { ProductCollections } from '../../../models/product';

@Component({
  selector: 'app-home-carousel-sweater',
  imports: [MatButtonModule, MatRippleModule, RouterModule],
  templateUrl: './home-carousel-sweater.html',
  styleUrl: './home-carousel-sweater.scss',
})
export class HomeCarouselSweater {
  get collectionNo(): string {
    return ProductCollections.Sweaters;
  }
}
